import { CurrencyModel } from '../../../../../../../models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from '../../../../../../ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  INVOICE = 'invoice',
}

export enum OrderByEnum {
  INVOICE_DATE = 'invoice_date',
  INVOICE_NUMBER = 'invoice_number',
  AMOUNT = 'amount',
}

export enum OrderDirectionEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export enum InvoiceTypeEnum {
  DEBIT_INVOICE = 'debit_invoice',
  CREDIT_INVOICE = 'credit_invoice',
  PROFORMA_INVOICE = 'proforma_invoice',
  INDIVIDUAL_INVOICE = 'individual_invoice',
}

export interface AccountsReceivableSalesJournalReportFormModel {
  from: string | null;
  to: string | null;
  crs_number: string | null;
  card_ids: ReservationCardGroupModel[];
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  invoice_types: InvoiceTypeEnum[] | null;
  order_by: OrderByEnum | null;
  sens: OrderDirectionEnum | null;
  file_type: exportFileTypes;
}
